<app-admin-nav></app-admin-nav>

<div class="home">
  <h2>Admin</h2>
  <p class="sub">Everything behind the NX2U admin login, in three sections.</p>

  <div class="cards">
    <a class="card" routerLink="/admin/people">
      <h3>People</h3>
      <p>
        Every account, from four sides: scored and tiered from core to dormant,
        their one-to-one chats and whether those got answered, where they are on
        the map, and who is still just a name.
      </p>
      <div class="tabs">
        <span>Members</span><span>Chats</span><span>Map</span><span>Profile completion</span>
      </div>
    </a>

    <a class="card" routerLink="/admin/spaces">
      <h3>Spaces</h3>
      <p>
        Every event, its organizer and members, whether its lobby is a
        conversation or a noticeboard, and how far each invited organizer got
        towards claiming it.
      </p>
      <div class="tabs">
        <span>Events</span><span>Lobbies</span><span>Claim funnel</span>
      </div>
    </a>

    <a class="card" routerLink="/admin/abuse" [class.attention]="needsAttention">
      <h3>Abuse</h3>
      <p>
        Flagged and banned accounts, appeals, the watchlist and the guard's
        thresholds — block, dismiss, purge chat traces.
      </p>
      <div class="counts" *ngIf="overview">
        <span [class.hot]="overview.awaitingReview > 0">
          {{ overview.awaitingReview }} awaiting review
        </span>
        <span [class.hot]="overview.reports24h > 0">
          {{ overview.reports24h }} reports 24h
        </span>
        <span>{{ overview.bannedTotal }} banned</span>
      </div>
    </a>
  </div>
</div>
